import DatabaseService from 'shared/db/services/Database.web';
import Organisation from 'shared/db/services/Organisation';
import { OrganisationPayload } from 'shared/types/Organisation';

import { databaseValidation } from '@/services/databaseValidation';
import { FirebaseImagesService } from '@/services/firebase/images';
import Logger from '@/services/logger';
import { OrganisationsAPI } from '@/services/networking/organisations';
import { Organisation as OrganisationType } from '@/types/organisations';

async function getUserDefaultOrganisation(): Promise<
    OrganisationType | undefined
> {
    const data = await OrganisationsAPI.getOrganisations();

    const defaultOrganisation = data?.payload?.organisations?.find(
        (org) => org.owner === true,
    );

    return defaultOrganisation;
}

function getOrganisationService(): Organisation {
    return new Organisation({
        imageService: new FirebaseImagesService(),
        database: DatabaseService.getDatabase(),
        logDBAction: Logger.logRecordActivity,
        validation: databaseValidation,
    });
}

async function updateDefaultInvoiceDueDays(params: {
    totalDays: number;
    userId: string;
}): Promise<void> {
    await getOrganisationService().update({
        payload: {
            defaultInvoiceDueDays: params.totalDays,
        } satisfies Partial<OrganisationPayload>,
        userId: params.userId,
    });
}

async function getLocalDefaultInvoiceDueDays(): Promise<number | undefined> {
    const [organisation] = await getOrganisationService().get();

    return organisation?.defaultInvoiceDueDays ?? undefined;
}

export {
    getUserDefaultOrganisation,
    updateDefaultInvoiceDueDays,
    getLocalDefaultInvoiceDueDays,
};
